<form class="form-popup" [formGroup]="formGroup">
  <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <input
          matInput
          type="text"
          name="description"
          formControlName="description"
          [max]=80
      />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Barcode</mat-label>
        <input matInput type="text" name="Barcode"
                class="fullWidth"
                formControlName="barcode"
                [maxlength]=25
        />
  </mat-form-field>

  <div style="margin-left: 0px; margin-bottom: 20px;"><i>Move to Existing Item, New Item Number or Keep Item Number</i></div>

  <mat-radio-group formControlName="target" (change)="radioChange($event)" >
    <mat-radio-button value="existing">Existing</mat-radio-button>
    <mat-radio-button value="new">New</mat-radio-button>
    <mat-radio-button value="keep">Keep</mat-radio-button>
  </mat-radio-group>

  <aims-lookup
    class="fullWidth"
    name="Lookup Item"
    [gridText]="'Select an Item'"
    id="inventoryItemLookup"
    [values]="inventory | async"
    [idPropertyName]="'barcode'"
    [displayPropertyName]="'barcode'"
    [columnsInGrid]="itemLookupColumns"
    (valueChangeObj)="handleItemLookupChange($event)"
    formControlName="itemlookup"
  >
  </aims-lookup>

  <mat-form-field appearance="fill">
      <mat-label>New Barcode</mat-label>
        <input matInput type="text" name="NewBarcode"
                        class="fullWidth"
                        formControlName="newbarcode"
                        [maxlength]=25
        />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Site</mat-label>
    <mat-select
      name="site"
      formControlName="site"
      (selectionChange)="siteChange($event)"
      required>
        <mat-option *ngFor="let s of sites" [value]="s.siteId">
          {{ s.siteName }}
        </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Location</mat-label>
    <mat-select
      name="location"
      formControlName="location"
      (selectionChange)="locationChange($event)">
      <mat-option *ngFor="let l of locations| async" [value]="l.locationId">
          {{ l.location }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Sub-Location</mat-label>
    <mat-select name="sublocation" formControlName="sublocation" >
      <mat-option *ngFor="let sl of sublocations| async" [value]="sl.subLocationId">
        {{ sl.subLocation }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Quantity To Move</mat-label>
    <input matInput
      #quantity
      formControlName="quantity"
      name="Quantity Wanted"
      [min]="1"
      [max]="origQuantity"
      type="number"
    />
  </mat-form-field>

</form>
